// German for the NEXT MOVE zone: the zone note, the disclosure and each rule's verb.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Next move': 'Nächster Zug',
  '{n} queued': '{n} in der Warteschlange',
  'across the live engagements': 'über die aktiven Aufträge',
  '{n} more, ranked': '{n} weitere, nach Rang',
  'derived check': 'abgeleitete Prüfung',
  // the CTA map — a property of the rule
  'New engagement': 'Neuer Auftrag',
  'Open Lifecycle': 'Lebenszyklus öffnen',
  'Open the register': 'Register öffnen',
  'Open the commitment': 'Zusage öffnen',
  'Open the review queue': 'Prüfwarteschlange öffnen',
  'Open the conflicts': 'Konflikte öffnen',
  'Review the facts': 'Fakten prüfen',
  'Open the questions': 'Fragen öffnen',
  'Open Contracting': 'Vertrag öffnen',
  'Open the task': 'Aufgabe öffnen',
  'Open': 'Öffnen',
}, 'ClientNextMove');
